export class Utils {
  /**
   * @description Auxiliary error callback used when not defined within client call
   * */
  public static auxErrorCallback(err: any) {
    console.log('Error:', err);
  }

  /**
   * @description Auxiliary success callback used when not defined within client call
   * */
  public static auxSuccessCallback(deviceId: string) {
    console.log('DeviceID:', deviceId);
  }

  /**
   * Get location search string.
   * @returns {string}
   */
  public static getLocationSearch(): string {
    return location.search;
  }

  /**
   * Gets value,
   * if undefined, null or error it returns a default value.
   * Use this function to get Object values safely.
   *
   * ie: const myVar = Utils.getValue(() => someObject.someProp.SomeChildProp, defaultsTo);
   *
   * @param value - The value to get.
   * @param defaultsTo - The default value to get if undefined, null or error.
   * @return any
   */
  public static getValue(value: any, defaultsTo: any): any {
    let safeValue: any;

    try {
      safeValue = value();
    } catch (e) {
      return defaultsTo;
    }

    if (this.isDefined(safeValue) && safeValue !== null && safeValue !== '') {
      return safeValue;
    } else {
      return defaultsTo;
    }
  }

  /**
   * Get window object.
   * @returns {Window}
   */
  public static getWindow(): Window {
    return window;
  }

  /**
   * Checks if a value is defined.
   *
   * @param value - The value to check.
   * @return boolean
   */
  public static isDefined(value: any): boolean {
    return typeof value !== 'undefined';
  }

  /**
   * Gets location search.  Added to function so we can stub it in tests.
   *
   * @returns string
   */

  /**
   * Checks if a value is empty
   *
   * @param value
   * @return boolean
   */
  public static isEmpty(value: any): boolean {
    return (
      !this.isDefined(value) ||
      value === '' ||
      value === false ||
      value === 0 ||
      value === null ||
      this.isEmptyObject(value)
    );
  }

  /**
   * Gets the window.  Added to function so we can stub it in tests.
   * @returns object
   */

  /**
   * Checks if obj is an empty Object.
   *
   * @param value - The value to check.
   * @return boolean
   */
  public static isEmptyObject(value: any): boolean {
    if (typeof value !== 'object') {
      return false;
    }

    return !Object.values(value).length;
  }

  /**
   * Parse JSON string to JS Object.
   * @param jsonString - The JSON string to parse.
   * @return JS object. If any error, it returns null.
   */
  public static parseJSON(jsonString: string): any {
    let data: any;

    try {
      data = JSON.parse(jsonString);
    } catch (e) {
      console.info(`[Utils] Error parsing JSON string: ${e.message}`, e);
      return null;
    }
    if (null === jsonString) {
      console.info('[Utils] jsonString is null');
      return null;
    }

    return data;
  }
}
